import { FluentProvider } from "@fluentui/react-components";
import { QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";

import { ErrorBoundary } from "@/components/ErrorBoundary";
import { DeepLinkHandler } from "@/features/auth/DeepLinkHandler";
import { TeamsAuthProvider, useTeamsAuth } from "@/features/auth/TeamsAuthProvider";
import { queryClient } from "@/lib/queryClient";
import { Configure } from "@/routes/Configure";
import { Review } from "@/routes/Review";
import { Root } from "@/routes/Root";
import { fluentThemeFor } from "@/theme/fluentTheme";

function ThemedShell() {
  const { theme } = useTeamsAuth();
  return (
    <FluentProvider theme={fluentThemeFor(theme)} style={{ minHeight: "100vh" }}>
      <HashRouter>
        <DeepLinkHandler />
        <Routes>
          <Route path="/" element={<Root />} />
          <Route path="/configure" element={<Configure />} />
          <Route path="/review/:id" element={<Review />} />
          <Route path="*" element={<Root />} />
        </Routes>
      </HashRouter>
    </FluentProvider>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <TeamsAuthProvider>
          <ThemedShell />
        </TeamsAuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
